import React, { PureComponent } from 'react'
import cn from 'classnames'
import Tag from 'components/common/elements/Tag/Tag'
import Icon from 'components/common/elements/Icon'
import ReactTooltip from 'react-tooltip'

import styles from './Search.scss'

class Search extends PureComponent {
  constructor() {
    super();
    this.state = {
      search: '',
      showOverlay: false
    };
  }
  render () {
    const { searchOpened, isMenuOpen, hide, toggle } = this.props;
    const { search, showOverlay } = this.state;
    return (
      <div className={ styles.globalMenuSearch }>
        <span className={cn(styles.searchBtn+ ' MenuIcon', {onlyIcon: !isMenuOpen, "gs-tooltip": !isMenuOpen})}
              data-tip="Open Search"
              onClick={() => this.setState({showOverlay:true})}
              role='button'>
          <Icon icon={'zoom'}
                width='46'
                height="46"
                role="button"/>
          <span className="gs-text">Search Form</span>
        </span>
        { showOverlay &&
          <div className={styles.globalMenuSearchOverlay}>
            <div className={styles.globalMenuSearchOverlayContainer}>
              <div className={styles.globalMenuSearchOverlayContainerRow}>
                <div className={styles.formSearchWrap}>
                  <form className={styles.globalMenuSearchOverlayContainerForm}>
                    <input className={styles.searchInput}
                           placeholder="Type and hit Enter..."
                           value={search}
                           onChange={e => this.setState({search:e.target.value}) }
                           type="text"/>
                    <span role="button" onClick={() => this.setState({showOverlay:false}) }>
                      <Icon icon={'Cross'}
                            width='56'
                            height="56"
                            color="white"
                            fill="white"
                            role="button"/>
                    </span>
                  </form>
                { search &&
                  <div className={styles.results}>
                    <div className={styles.resultsList}>
                      <div className={styles.resultsList__item}>
                        <b>{search}</b>ala
                      </div>
                      <div className={styles.resultsList__item}>
                        <b>{search}</b>tre
                      </div>
                      <div className={styles.resultsList__item}>
                        <b>{search}</b>rol
                      </div>
                      <div className={styles.resultsList__item}>
                        <b>{search}</b>tes
                      </div>
                      <div className={styles.resultsList__item}>
                        <b>{search}</b>role
                      </div>
                      <div className={styles.resultsList__item}>
                        <b>{search}</b> forest
                      </div>
                      <div className={styles.resultsList__item}>
                        <b>{search}</b>rolex
                      </div>
                      <div className={styles.resultsList__item}>
                        <b>{search}</b>testing
                      </div>
                      <div className={styles.resultsList__item}>
                        <b>{search}</b>ro
                      </div>
                      <div className={styles.resultsList__item}>
                        <b>{search}</b> ext
                      </div>
                    </div>
                    <div className={styles.resultsFilter}>
                      <Tag label="Company Name"/>
                      <Tag label="Friends"/>
                      <Tag label="Industry"/>
                      <Tag label="Country"/>
                      <Tag label="City"/>
                      <Tag label="Old"/>
                      <Tag label="Popular"/>
                      <Tag label="Newest"/>
                      <Tag label="LinkedIn"/>
                      <Tag label="Xing"/>
                      <Tag label="Facebook"/>
                      <Tag label="Vkontakte"/>
                      <Tag label="Music"/>
                      <Tag label="Marketing"/>
                      <Tag label="Internet"/>
                      <Tag label="Footbal"/>
                      <Tag label="Winter"/>
                      <Tag label="Canada, Vancouver, Omsk, 554234"/>
                      <Tag label="Mobile phone"/>
                      <Tag label="Nokia"/>
                      <Tag label="Company Name"/>
                      <Tag label="Friends"/>
                      <Tag label="Industry"/>
                      <Tag label="Country"/>
                      <Tag label="City"/>
                      <Tag label="Old"/>
                      <Tag label="Popular"/>
                      <Tag label="Newest"/>
                      <Tag label="LinkedIn"/>
                      <Tag label="Xing"/>
                      <Tag label="Facebook"/>
                      <Tag label="Vkontakte"/>
                      <Tag label="Music"/>
                      <Tag label="Marketing"/>
                      <Tag label="Internet"/>
                      <Tag label="Footbal"/>
                      <Tag label="Winter"/>
                      <Tag label="Canada, Vancouver, Omsk, 554234"/>
                      <Tag label="Mobile phone"/>
                      <Tag label="Nokia"/>
                    </div>
                  </div>
                }
                </div>
              </div>
            </div>
          </div>
        }
        <ReactTooltip effect="solid" place="bottom"/>
      </div>
    )
  }
}

export default Search
